declare let process: { env: { [key: string]: string } };

export const environment = {
  api: process.env.API_ENDPOINT,
  imageUrl: process.env.IMAGE_URL
};
